// eslint-disable-next-line import/no-anonymous-default-export
export default [
    { id: 1 , nome:"Boneca" , preço: 18.75},
    { id: 2 , nome:"Caneca" , preço: 8.50}, 
    { id: 3 , nome:"Bola" , preço: 30.75}, 
    { id: 4 , nome:"Carrinho" , preço: 10.90}, 
    { id: 5 , nome:"Bicicleta" , preço: 1800.00}, 
]